import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })

export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthenticationService,
    private router: Router,
  ) { }

  canActivate() {
    if (this.authService.isAuthenticated()) {
      
      // If navigating to login while authenticated,
      // redirect to home page
      return true;
    } else {
      this.router.navigate(['/login']);
    }
    return false;
  }
}
